<script setup>
</script>

<template>
  <div class="git-container background-cover position-relative">
    <div class="git-graph position-absolute background-cover desktop" />
    <div class="text-white d-flex ph-20 h-100 justify-center align-items-center">
      <div class="whatsapp-strip">
        <i class="pi pi-whatsapp whatsapp-icon"></i>
        <span class="contact-text">Contact us on WhatsApp:</span>
        <a href="https://wa.me/919958836060" target="_blank" class="phone-number">+91 9958836060</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.git-container {
  height: 80px;
  background-color: var(--an-primary);
  background-image: var(--an-auth-grain);
}

.git-graph {
  background: var(--an-graph2);
  width: 380px;
  height: 300px;
  background-repeat: no-repeat;
  bottom: 0;
}

.whatsapp-strip {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  backdrop-filter: blur(10px);
}

.whatsapp-icon {
  font-size: 1.25rem;
  color: #25D366;
}

.contact-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #ffffff;
}

.phone-number {
  font-size: 0.9rem;
  font-weight: 700;
  color: #ffffff;
  text-decoration: none;
  transition: color 0.2s ease;
}

.phone-number:hover {
  color: #25D366;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .git-container {
    height: 70px;
  }

  .whatsapp-strip {
    gap: 8px;
    padding: 6px 16px;
  }

  .whatsapp-icon {
    font-size: 1.1rem;
  }

  .contact-text {
    font-size: 0.8rem;
  }

  .phone-number {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .contact-text {
    display: none;
  }

  .whatsapp-strip {
    gap: 10px;
  }
}
</style>
